// @flow

// File name of a project export download: address line 1, the module label, then the extension, e.g.
// "965 Rubina St Notes.pdf", "965 Rubina St Photos.zip", "965 Rubina St Bid.xlsx". Used by the Notes,
// Photos, Attachments, Bid and Budget exports, and matches the name the backend gives the emailed notes PDF.
export function buildExportFileName(streetAddress: ?string, label: string, extension: string): string {
  return `${[streetAddress?.trim(), label].filter(Boolean).join(" ")}.${extension}`;
}

// File name from a Content-Disposition response header, or null when the header is missing or has no name.
// Prefers the RFC 5987 form (filename*=UTF-8''965%20Rubina%20St.zip) over the plain filename="...".
// The backend must list Content-Disposition in Access-Control-Expose-Headers for the browser to share it.
export function getFileNameFromContentDisposition(header: ?string): ?string {
  if (!header) return null;
  const encoded = header.match(/filename\*\s*=\s*(?:[\w-]+'[^']*')?"?([^";]+)"?/i);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim());
    } catch (error) {
      // Malformed encoding: fall through to the plain filename.
    }
  }
  const plain = header.match(/filename\s*=\s*"([^"]*)"|filename\s*=\s*([^;]+)/i);
  const name = plain && (plain[1] ?? plain[2])?.trim();
  return name || null;
}
